module.exports = __webpack_public_path__ + "img/bed-img.0717ec50.png";